import SendFromAddress from "./SendFromAddress";

class EmailServer {
    id: number;
    schoolID: number;

    useSSL: boolean;
    address: string;
    port: number;

    useCredentials: boolean;
    userName: string;
    password: string;

    tested?: boolean;
    serverTesting: boolean;
    errorMessage: string;

    sendFromAddresses: SendFromAddress[];

    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy: number;
    recycledOn: Date;

    constructor(data?: Partial<EmailServer>) {
        Object.assign(this, data);

        if (data.sendFromAddresses)
            this.sendFromAddresses = data.sendFromAddresses
                .map(data => new SendFromAddress(data));
    }
}

export default EmailServer;